import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

export default function FAQ() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      {/* Header */}
      <div className="p-4 border-b border-gray-700">
        <div className="flex items-center space-x-4">
          <Link to="/boards">
            <Button 
              variant="ghost" 
              size="sm"
              className="text-gray-300 hover:text-white"
            >
              <ChevronLeft className="h-4 w-4 mr-2" />
              Back to My DoDue Space
            </Button>
          </Link>
          <h1 className="text-xl font-semibold">DoDueLife Help Center</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-2xl mx-auto mt-12 p-6">
        <div className="bg-slate-800 rounded-lg p-8 shadow-lg text-center">
          <h2 className="text-3xl font-bold mb-4">Coming Soon</h2>
          <p className="text-gray-300">
            Our help section is currently under construction. 
            For now, please email us at{" "}
            <a 
              href="mailto:support@doduelife.com" 
              className="text-blue-400 hover:text-blue-300"
            >
              support@doduelife.com
            </a>
            {" "}with any questions.
          </p>
        </div>
      </div>
    </div>
  );
} 